export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/b552ae94a3baa9664c4076d726380c66.svg";